<template>
  <div class="bodyStep4">
    <div class="step4">
      <div class="title"><p class="title_info">涉及化学品登记</p></div>
      <div class="tableMessage">
        <el-button
          v-if="step != 5"
          v-preventReClick
          type="primary"
          icon="el-icon-plus"
          @click="addMes"
        >逐条添加化学品</el-button>
        <div class="tablemes">
          <el-table
            :data="
              tableData.slice(
                (currentPage - 1) * pagesize,
                currentPage * pagesize
              )
            "
            border
            style="width: 100%"
          >
            <el-table-column
              v-for="(item, i) in table"
              :key="i"
              :show-overflow-tooltip="true"
              align="center"
              :label="item.label"
              :prop="item.prop"
            >
              <template slot-scope="scope">
                <span :title="scope.row[item.key]">
                  {{
                    item.key == "nsjsl" && scope.row["nsjslDwLabel"] != null
                      ? scope.row[item.key] +
                        "  (" +
                        scope.row["nsjslDwLabel"] +
                        ")"
                      : scope.row[item.key]
                  }}
                </span>
              </template>
            </el-table-column>
            <el-table-column v-if="step != 5" label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  v-preventReClick
                  :disabled="step == 5"
                  type="primary"
                  icon="el-icon-edit"
                  size="mini"
                  @click="handleEdit(scope.$index, scope.row)"
                >编辑</el-button>
                <el-button
                  v-preventReClick
                  :disabled="step == 5"
                  size="mini"
                  type="warning"
                  icon="el-icon-delete"
                  @click="handleDelete(scope.$index, scope.row)"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev, pager,next,jumper,total,sizes"
            :total="tableData.length"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pagesize"
            :current-page.sync="currentPage"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </div>
      <div class="zhengjian">
        <p>上传资质证件</p>
        <ul class="uploadzhengjian">
          <li v-for="(item, i) in imgListArray" :key="i">
            <img
              v-preventReClick
              :src="item.imageurl"
              alt=""
              @click="imageClick(item.name, item.zjlx)"
            >

            <p
              v-if="step != 5"
              v-preventReClick
              @click="exportMb"
              v-html="item.xianshi"
            />
            <p v-if="step == 5 && item.zjlx == 22" v-html="item.name" />
            <p v-if="step == 5 && item.zjlx != 22" v-html="item.xianshi" />
          </li>
        </ul>
      </div>
      <div v-if="step != 5" class="_buttonList">
        <el-button v-preventReClick @click="upstep">上一步</el-button>
        <el-button
          v-preventReClick
          type="primary"
          @click="nextstep"
        >下一步</el-button>
      </div>
    </div>

    <!-- 打开许可证弹窗 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :visible.sync="dialogFormVisible1"
      center
      custom-class="zhengjiatable"
    >
      <div v-if="step != 5" class="addButton" style="background: #f4f4f4">
        <el-button
          v-preventReClick
          type="primary"
          icon="el-icon-plus"
          size="mini"
          :disabled="step == 5"
          style="background-color: #4170ff; margin: 9px"
          @click="addImageMes"
        >添加</el-button>
      </div>

      <el-table
        :data="imagetableData"
        border
        style="width: 100%"
        max-height="420"
      >
        <el-table-column
          v-for="(item, i) in headerlist"
          :key="i"
          align="center"
          :prop="item.prop"
          :label="item.label"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="操作"
          :width="step == 5 ? '180' : '340'"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              v-preventReClick
              type="primary"
              icon="el-icon-view"
              size="mini"
              style="background-color: #4170ff"
              @click="handleView(scope.$index, scope.row)"
            >查看</el-button>
            <el-button
              v-if="step != 5"
              v-preventReClick
              type="primary"
              icon="el-icon-edit"
              size="mini"
              :disabled="step == 5"
              style="background-color: #4170ff; margin-left: 22px"
              @click="editImageMes(scope.$index, scope.row)"
            >编辑</el-button>
            <el-button
              v-if="step != 5"
              v-preventReClick
              type="warning"
              icon="el-icon-delete"
              size="mini"
              style="
                background-color: #ed5e0b;
                border-color: #ed5e0b;
                margin-left: 22px;
              "
              :disabled="step == 5"
              @click="deleteImageMes(scope.$index, scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 许可证弹窗的弹窗start -->
      <dialog-1
        ref="dialog1"
        :step="step"
        :type="type"
        :dialog-form-visible="dialogFormVisible"
        :title="title"
        :zjlx="imagezjlx"
        @close-dialog="closeDialog"
        @getFjTableMess="getFjTableMess1"
      />
      <!-- 许可证弹窗的弹窗end -->
      <div slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          type="primary"
          style="
            background-color: #4170ff;
            width: 90px;
            height: 40px;
            margin-bottom: 20px;
          "
          @click="dialogFormVisible1 = false"
        >关闭</el-button>
      </div>
    </el-dialog>
    <!-- 打开许可证弹窗end -->

    <!-- 添加化学品弹窗 -->
    <div>
      <el-dialog
        v-if="dialogVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :visible.sync="dialogVisible"
        destroy-on-close
        custom-class="waibu"
        center
      >
        <chemicalPupop
          ref="chemicalPupop"
          :content="content"
          :puptype="puptype"
        />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import chemicalPupop from '@/components/chemicalPupop'
import dialog1 from './dialog.vue'
import {
  gethxpMes,
  deletehxpMes,
  deleteFjMes,
  saveHxpxx,
  getFjTableMes,
  getFjTableMesById,
  getFjType,
  deleteImageMes
} from '@/assets/js/common.js'
export default {
  components: {
    chemicalPupop,
    dialog1
  },
  props: {
    step: Number
  },
  data() {
    return {
      content: {},
      puptype: '',
      title: '', // 传给弹出框的标题
      dialogVisible: false,
      dialogFormVisible1: false,
      type: '', // 类型，添加还是查看
      currentPage: 1, // 当前页
      pagesize: 10, // 每页的数据条数
      total: 0, // 总条数
      dialogFormVisible: false, // 对话框的显示隐藏
      tableData: [], // 表格数据
      imgListArray: [], // 许可证图片
      imagezjlx: 0,
      zjlxs: [],
      imagetableData: [], // image列表table
      headerlist: [], // 许可证列表表头
      // 化学品列表表头
      table: [
        { prop: 'hxpmc', key: 'hxpmc', label: '化学品名称' },
        { prop: 'ywlxLabel', key: 'ywlxLabel', label: '业务类型' },
        { prop: 'hxpLbLabel', key: 'hxpLbLabel', label: '化学品类别' },
        { prop: 'nsjsl', key: 'nsjsl', label: '年涉及数量' },
        { prop: 'yt', key: 'yt', label: '用途' }
      ]
    }
  },
  computed: {},
  watch: {},
  created() {
    this.gethxpMess({
      page: this.currentPage,
      size: this.pagesize
    })
  },
  mounted() {},
  methods: {
    changeStatus($event) {
      console.log($event)
    },
    // 获取证件信息
    getFjMess(zjlx) {
      getFjMes(this.$store.state.RWLCType).then((e) => {
        var res = e.data.data.filter((item) => {
          return item.zjlx == zjlx
        })
        if (res.length > 0) this.$refs.dialog1.csh(res)
      })
    },
    // 获得许可证弹窗信息
    getFjTableMess(zjlx) {
      // 查询许可证附件table信息
      getFjTableMes(this.$store.state.RWLCType, zjlx).then((e) => {
        this.imagetableData = e.data.data
        switch (zjlx) {
          case 2: // 非药品类易制毒化学品生产许可证
            this.headerlist = []
            this.headerlist.push(
              { prop: 'zjbh', label: '编号' },
              { prop: 'pzcl', label: '生产品种' },
              { prop: 'dwmc', label: '单位名称' },
              { prop: 'yxqKs', label: '有效期开始' },
              { prop: 'yxqJs', label: '有效期结束' },
              { prop: 'fzjg', label: '发证机关' }
            )
            break
          case 3: // 非药品类易制毒化学品经营许可证
            this.headerlist = []
            this.headerlist.push(
              { prop: 'zjbh', label: '证件编号' },
              { prop: 'tyshxydm', label: '统一社会信用代码' },
              { prop: 'pzcl', label: '经营品种' },
              { prop: 'dwmc', label: '单位名称' },
              { prop: 'fzr', label: '主要负责人' },
              { prop: 'yxqKs', label: '有效期开始' },
              { prop: 'yxqJs', label: '有效期结束' }
            )
            break
          case 13: // 非药品类易制毒化学品生产备案证明
            this.headerlist = []
            this.headerlist.push(
              { prop: 'zjbh', label: '编号' },
              { prop: 'pzlb', label: '品种类别' },
              { prop: 'dwmc', label: '单位名称' },
              { prop: 'fzr', label: '主要负责人' },
              { prop: 'yxqKs', label: '有效期开始' },
              { prop: 'yxqJs', label: '有效期结束' }
            )
            break
          case 17: // 非药品类易制毒化学品经营备案证明
            this.headerlist = []
            this.headerlist.push(
              { prop: 'zjbh', label: '编号' },
              { prop: 'dwmc', label: '单位名称' },
              { prop: 'tyshxydm', label: '统一社会信用代码' },
              { prop: 'pzcl', label: '经营品种' },
              { prop: 'fzr', label: '主要负责人' },
              { prop: 'yxqKs', label: '有效期开始' },
              { prop: 'yxqJs', label: '有效期结束' }
            )
            break
          case 6: // 安全生产许可证
            this.headerlist = []
            this.headerlist.push(
              { prop: 'zjbh', label: '证件编号' },
              { prop: 'dwmc', label: '单位名称' },
              { prop: 'fzr', label: '主要负责人' },
              { prop: 'jyfw', label: '许可范围' },
              { prop: 'yxqKs', label: '有效期开始' },
              { prop: 'yxqJs', label: '有效期结束' }
            )
            break

          case 22: // 合法使用需要证明
            this.headerlist = []
            this.headerlist.push(
              { prop: 'dwmc', label: '单位名称' },
              { prop: 'hxpMcs', label: '化学品名称' },
              { prop: 'sjl', label: '涉及量' },
              { prop: 'fzrq', label: '签订日期' }
            )
            break
          case 16: // 危险化学品经营许可
            this.headerlist = []
            this.headerlist.push(
              { prop: 'zjbh', label: '证件编号' },
              { prop: 'dwmc', label: '单位名称' },
              { prop: 'fzr', label: '单位法定代表人' },
              { prop: 'jyfw', label: '许可范围' },
              { prop: 'yxqKs', label: '有效期开始' },
              { prop: 'yxqJs', label: '有效期结束' }
            )
            break
          case 12: // 道路运输经营许可
            this.headerlist = []
            this.headerlist.push(
              { prop: 'zjbh', label: '证件编号' },
              { prop: 'dwmc', label: '业户名称' },
              { prop: 'yxqKs', label: '有效期开始' },
              { prop: 'yxqJs', label: '有效期结束' }
            )
            break
          case 23: // 其他证件
            this.headerlist = []
            this.headerlist.push(
              { prop: 'zsmc', label: '证书名称' },
              { prop: 'zjbh', label: '证件编号' },
              { prop: 'yxqKs', label: '有效期开始' },
              { prop: 'yxqJs', label: '有效期结束' }
            )
            break
          case 24: // 危险货物道路运输许可证
            this.headerlist = []
            this.headerlist.push(
              { prop: 'zjbh', label: '证件编号' },
              { prop: 'dwmc', label: '业户名称' },
              { prop: 'yxqKs', label: '有效期开始' },
              { prop: 'yxqJs', label: '有效期结束' },
              { prop: 'fzrq', label: '发证日期' }
            )
            break
          default:
            break
        }
      })
    },
    getFjTableMess1(val) {
      this.imagetableData = val
      this.imageChange()
    },
    // 许可证弹窗
    imageClick(name, zjlx) {
      this.title = name
      this.imagezjlx = zjlx
      this.getFjTableMess(zjlx)
      this.dialogFormVisible1 = true
    },
    // 许可证弹窗列表查看
    handleView(index, row) {
      this.dialogFormVisible = true
      this.type = true
      getFjTableMesById(this.$store.state.RWLCType, row.id).then((e) => {
        this.$refs.dialog1.csh(e.data.data)
      })
    },
    // 许可证弹窗列表编辑
    editImageMes(index, row) {
      this.dialogFormVisible = true
      this.type = false
      getFjTableMesById(this.$store.state.RWLCType, row.id).then((e) => {
        this.$refs.dialog1.csh(e.data.data)
      })
    },
    // 许可证弹窗列表删除
    deleteImageMes(index, row) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteImageMes(row.id, this.$store.state.RWLCType)
            .then((e) => {
              this.getFjTableMess(this.imagezjlx)
              this.imageChange()
              this.$message.success('删除成功')
            })
            .catch((error) => {
              this.$message.error('删除失败')
            })
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },
    // 许可证弹窗列表添加信息
    addImageMes() {
      this.dialogFormVisible = true
      this.type = false
    },
    // 关闭许可证弹窗的弹窗
    closeDialog(val1, val2) {
      this.dialogFormVisible = false
    },
    // 许可证变化
    async imageChange() {
      var zjlxList = []
      await getFjType(this.$store.state.RWLCType).then((e) => {
        zjlxList = e.data.data.zjlxs.split(',')
      })
      this.imgListArray = []
      this.zjlxs = []
      if (this.tableData.length == 0) {
        this.zjlxs.push('23')
        return
      }
      // 生产类必有
      var res1 = this.tableData.some((item, index, arr) => {
        return item.ywlxLabel == '生产' // 有一项成员通过就true
      })
      res1 == true
        ? this.imgListArray.push({
          zjlx: 6,
          name: '安全生产许可证',
          xianshi: '安全生产许可证',
          imageurl: zjlxList.includes('6')
            ? require('../assets/img/step41.png')
            : require('../assets/img/step41_down.png'),
          flag: false
        })
        : this.zjlxs.push('6')
      // 生产1类
      var res2 = this.tableData.some((item, index, arr) => {
        return item.ywlxLabel == '生产' && item.hxpLb == '100'
      })
      res2 == true
        ? this.imgListArray.push({
          zjlx: 2,
          name: '非药品类易制毒化学品生产许可证',
          xianshi:
              " <span style='color: red;'>*</span>非药品类易制毒化学品生产许可证",
          imageurl: zjlxList.includes('2')
            ? require('../assets/img/step42.png')
            : require('../assets/img/step42_down.png'),
          flag: true
        })
        : this.zjlxs.push('2')
      // 生产2,3类
      var res3 = this.tableData.some((item, index, arr) => {
        return (
          item.ywlxLabel == '生产' &&
          (item.hxpLb == '200' || item.hxpLb == '300')
        )
      })
      res3 == true
        ? this.imgListArray.push({
          zjlx: 13,
          name: '非药品类易制毒化学品生产备案证明',
          xianshi:
              " <span style='color: red;'>*</span>非药品类易制毒化学品生产备案证明",
          imageurl: zjlxList.includes('13')
            ? require('../assets/img/step43.png')
            : require('../assets/img/step43_down.png'),
          flag: true
        })
        : this.zjlxs.push('13')

      // 经营类必有  //仓储类必有
      var res11 = this.tableData.some((item, index, arr) => {
        return item.ywlxLabel == '经营' || item.ywlxLabel == '仓储' // 有一项成员通过就true
      })
      res11 == true
        ? this.imgListArray.push({
          zjlx: 16,
          name: '危险化学品经营许可证',
          xianshi: '危险化学品经营许可证',
          imageurl: zjlxList.includes('16')
            ? require('../assets/img/step47.png')
            : require('../assets/img/step47_down.png'),
          flag: false
        })
        : this.zjlxs.push('16')

      // 经营和使用必有
      var res12 = this.tableData.some((item, index, arr) => {
        return item.ywlxLabel == '经营' || item.ywlxLabel == '使用' // 有一项成员通过就true
      })
      res12 == true
        ? this.imgListArray.push({
          zjlx: 22,
          name: '合法使用需要证明',
          xianshi:
              "合法使用需要证明<br/><a style='color:blue;cursor: pointer;'>下载模板</a>",
          imageurl: zjlxList.includes('22')
            ? require('../assets/img/step44.png')
            : require('../assets/img/step44_down.png'),
          flag: false
        })
        : this.zjlxs.push('22')
      // 经营1类
      var res4 = this.tableData.some((item, index, arr) => {
        return item.ywlxLabel == '经营' && item.hxpLb == '100'
      })
      res4 == true
        ? this.imgListArray.push({
          zjlx: 3,
          name: '非药品类易制毒化学品经营许可证',
          xianshi:
              " <span style='color: red;'>*</span>非药品类易制毒化学品经营许可证",
          imageurl: zjlxList.includes('3')
            ? require('../assets/img/step46.png')
            : require('../assets/img/step46_down.png'),
          flag: true
        })
        : this.zjlxs.push('3')

      // 经营2和3类
      var res5 = this.tableData.some((item, index, arr) => {
        return (
          item.ywlxLabel == '经营' &&
          (item.hxpLb == '200' || item.hxpLb == '300')
        )
      })
      res5 == true
        ? this.imgListArray.push({
          zjlx: 17,
          name: '非药品类易制毒化学品经营备案证明',
          xianshi:
              " <span style='color: red;'>*</span>非药品类易制毒化学品经营备案证明",
          imageurl: zjlxList.includes('17')
            ? require('../assets/img/step48.png')
            : require('../assets/img/step48_down.png'),
          flag: true
        })
        : this.zjlxs.push('17')
      // 运输类
      var res6 = this.tableData.some((item, index, arr) => {
        return item.ywlxLabel == '运输'
      })
      res6 == true
        ? this.imgListArray.push(
          {
            zjlx: 12,
            name: '道路运输经营许可证',
            xianshi: " <span style='color: red;'>*</span>道路运输经营许可证",
            imageurl: zjlxList.includes('12')
              ? require('../assets/img/step49.png')
              : require('../assets/img/step49_down.png'),
            flag: true
          },
          {
            zjlx: 24,
            name: '危险货物道路运输许可证',
            xianshi: '危险货物道路运输许可证',
            imageurl: zjlxList.includes('24')
              ? require('../assets/img/step410.png')
              : require('../assets/img/step410_down.png'),
            flag: false
          }
        )
        : this.zjlxs.push('12', '24')

      if (this.tableData.length != 0) {
        // 必有  其他证件
        this.imgListArray.push({
          zjlx: 23,
          name: '其他证件',
          xianshi: '其他证件',
          imageurl: zjlxList.includes('23')
            ? require('../assets/img/step45.png')
            : require('../assets/img/step45_down.png'),
          flag: false
        })
      }
    },
    // 获取化学品信息
    gethxpMess(dataobj) {
      gethxpMes(
        {
          page: '',
          size: ''
        },
        this.$store.state.RWLCType
      ).then((e) => {
        // this.total = e.data.data.total;

        this.tableData = e.data.data
        this.imageChange() // 许可证变化
      })
    },

    // 当前页码改变时
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      // this.gethxpMess({
      //   page: this.currentPage,
      //   size: this.pagesize,
      // });
    },
    // 10条/页改变时
    handleSizeChange(val) {
      this.pagesize = val
      // this.gethxpMess({
      //   page: this.currentPage,
      //   size: this.pagesize,
      // });
    },
    // 编辑  打开化学品列表行数据弹窗
    handleEdit(index, row) {
      this.dialogVisible = true
      this.content = row
      this.puptype = 'edit'
    },
    // 保存编辑数据
    baosunEditData(data) {
      saveHxpxx(data, this.$store.state.RWLCType)
        .then((e) => {
          this.$message.success('修改成功')
          this.$refs.chemicalPupop.loadingFlag = false
          this.dialogVisible = false // 关闭编辑窗口
          this.gethxpMess({
            page: this.currentPage,
            size: this.pagesize
          })
        })
        .catch((e) => {
          this.$refs.chemicalPupop.loadingFlag = false
        })
    },
    // 打开 添加化学品列表行数据弹窗
    addMes() {
      this.puptype = 'add'
      this.content = {}
      this.dialogVisible = true
    },
    // 添加化学品数据
    closePupop(data) {
      saveHxpxx(data, this.$store.state.RWLCType)
        .then((e) => {
          this.dialogVisible = false
          this.$message.success('添加成功！')
          this.$refs.chemicalPupop.loadingFlag = false
          this.gethxpMess({
            page: this.currentPage,
            size: this.pagesize
          })
        })
        .catch((e) => {
          this.$refs.chemicalPupop.loadingFlag = false
        })
    },
    // 删除化学品行数据
    async handleDelete(index, row) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deletehxpMes(row.id, this.$store.state.RWLCType)
            .then((e) => {
              this.gethxpMess({
                page: this.currentPage,
                size: this.pagesize
              })
              this.$message.success('删除成功')
            })
            .catch((error) => {
              this.$message.error('删除失败')
            })
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },
    // 合法使用证明下载模板
    exportMb(e) {
      if (e.target.innerText.toString() == '下载模板') {
        const link = document.createElement('a')
        link.href = process.env.VUE_APP_PUBLIC_PORT + '/hfsyxyzm.doc'
        link.download = '模板'
        link.click()
      }
    },
    // 上一步
    upstep() {
      // 进行上一步
      this.$emit('nextstep', 3)
    },
    // 下一步
    nextstep() {
      var listzjlx = [] // 数据库里证件类型存在的证书
      var listzjlx1 = []
      var weitianxie = [] // 必填未填写的许可证名称
      var flag
      if (this.tableData.length == 0) {
        this.$message.error('未添加化学品')
      } else {
        getFjType(this.$store.state.RWLCType).then((e) => {
          listzjlx = e.data.data.zjlxs.split(',') // 数据库中的类型
          this.imgListArray.forEach((item) => {
            // 必需填写证书
            if (item.flag) {
              // 如果数据库中有this.imgListArray中的许可证证书信息，TRUE
              flag = listzjlx.includes(item.zjlx.toString())
              listzjlx1.push(flag)
              if (!flag) {
                weitianxie.push(item.name)
              }
            }
          })
          // listzjlx1中有false，说明数据库中有未包含的证书类型
          if (listzjlx1.includes(false)) {
            this.$message.error('请补全' + weitianxie.join(',') + '信息')
          } else {
            // 进行下一步
            this.$emit('nextstep', 5)
            // 将不需要的的证件信息删除
            deleteFjMes(
              {
                zjlxs: Array.from(new Set(this.zjlxs)).join(',')
              },
              this.$store.state.RWLCType
            ).then((e) => {
              console.log('输出成功')
            })
            listzjlx = []
            listzjlx1 = []
          }
        })
      }
    }
  }
}
</script>

<style lang="less" >
.bodyStep4 {
  background-color: #fff;
  margin: auto;
  overflow-y: auto;
  .waibu {
    min-width: 780px;
  }
  .step4 {
    max-width: 1127px;
    min-width: 890px;
    width: 90%;
    margin: auto;

    .title {
      overflow: hidden;
      margin-top: 50px;
      width: 175px;
      margin: auto;
      .title_info {
        width: 175px;
        height: 30px;
        font-size: 25px;
        font-family: Helvetica;
        color: #333333;
        line-height: 30px;
      }
    }
    .tableMessage {
      & > .el-button {
        width: 136px;
        height: 40px;
        // margin-left: 47px;
        margin-top: 35px;
        font-family: Medium;
        font-size: 13px;
        padding: 0;
      }

      .el-button--primary {
        color: #fff;
        background-color: #4170ff;
        border-color: #4170ff;
      }
      .tablemes {
        margin-top: 13px;
        margin-bottom: 40px;
        .el-table {
          //   margin-bottom: 10px;
        }
        .el-table td,
        .el-table th {
          padding: 8px 0;
          text-align: center !important;
        }
        .el-table td:last-child {
          //@y1216注掉
          //text-align: left !important;
        }
        .el-table th:nth-child(6) {
          // text-align: left !important;
        }
        .el-pagination__total {
          margin-left: 8px;
        }
        .el-pagination {
          padding: 10px 0;
          border: 1px solid #ebeef5;
          border-top: 0;
        }

        .el-button--warning {
          color: #fff;
          background-color: #ed5e0b;
          border-color: #ed5e0b;
        }
        .el-pagination.is-background .el-pager li:not(.disabled).active {
          background-color: #4170ff !important;
          color: #fff;
        }
      }
    }
    .zhengjian {
      & > p {
        width: 96px;
        height: 22px;
        margin-left: 25px;
        margin-bottom: 40px;
      }
      .uploadzhengjian {
        display: flex;
        flex-wrap: wrap;
        // justify-content: space-between;
        padding-left: 0 !important;
        li {
          width: 25%;
          list-style: none;
          text-align: center;
          img {
            cursor: pointer;
            width: 202px;
            height: 138px;
          }
          p {
            text-align: center;
            margin: 10px 0 20px;
            span {
              margin-right: 5px;
            }
          }
        }
      }
    }
  }
  ._buttonList {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 83px;
    button {
      width: 148px;
      height: 60px;
    }
    button:nth-child(2) {
      margin-left: 190px;
      background-color: #4170ff;
      color: white;
      border-color: #4170ff;
    }
  }
  .el-table--border::after,
  .el-table--group::after,
  .el-table::before {
    content: "";
    position: absolute;
    background: none;
    z-index: 1;
  }
  .el-table .has-gutter tr th {
    background: #f4f4f4;
  }
}
.zhengjiatable {
  width: 960px;
  .el-dialog__title {
    display: block;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 28px;
    margin: 30px auto 0px;
  }

  .el-dialog__body {
    overflow: auto;
    .el-switch {
      .el-switch__core {
        width: 80px !important;
        &::before {
          content: "证件关闭";
          color: #000;
          position: absolute;
          transform: scale(0.85);
          left: 20px;
        }
      }
      &.switch-is-actived {
        .el-switch__core {
          &::before {
            content: "证件开启";
            left: 5px;
            transform: scale(0.85);
          }
        }
      }
    }
  }
  .el-table--border,
  .el-table--group {
    border: 1px solid #ebeef5 !important;
  }
}
</style>
